import React, { useEffect, useState, useContext, memo } from "react";
import PropTypes from "prop-types";
import { useScroll } from "framer-motion";
import { Link, useLocation } from "react-router-dom";
import { Container, Navbar } from "react-bootstrap";

// Context
import GlobalContext from "../../Context/Context";

// css
import "../../Assets/scss/layouts/_header.scss";
import "./_header-override.scss";

/* Header Component Start */
export const HeaderLanding = memo((props) => {
  // Add Global Header Data
  const { setHeaderHeight } = useContext(GlobalContext);
  const { scrollY } = useScroll();
  const [scrollPos, setScrollPos] = useState({
    y: 0,
    prevY: -1,
    directionDown: true,
  });
  const location = useLocation();

  useEffect(() => {
    let headerEl = document.querySelector("header");

    // Calculate header height
    function setTopSpace() {
      let windowWidth = window.innerWidth,
        headerheight =
          props.topSpace.desktop && props.topSpace.desktop === true
            ? headerEl.offsetHeight
            : 0;

      if (windowWidth <= 1199 && props.topSpace.lg) {
        headerheight = props.topSpace.lg === true ? headerEl.offsetHeight : 0;
      }

      if (windowWidth <= 991 && props.topSpace.md) {
        headerheight = props.topSpace.md === true ? headerEl.offsetHeight : 0;
      }

      if (windowWidth <= 767 && props.topSpace.sm) {
        headerheight = props.topSpace.sm === true ? headerEl.offsetHeight : 0;
      }

      if (windowWidth <= 575 && props.topSpace.xs) {
        headerheight = props.topSpace.xs === true ? headerEl.offsetHeight : 0;
      }

      setHeaderHeight(headerheight);
    }

    setTopSpace();

    window.addEventListener("load", setTopSpace);
    window.addEventListener("resize", setTopSpace);

    return () => {
      window.removeEventListener("load", setTopSpace);
      window.removeEventListener("resize", setTopSpace);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  useEffect(() => {
    let lastScrollTop = 0;
    scrollY.onChange((pos) => {
      if (pos > lastScrollTop) {
        setScrollPos({
          ...scrollPos,
          y: pos,
          prevY: pos - 1,
          directionDown: true,
        });
      } else {
        setScrollPos({
          ...scrollPos,
          y: pos,
          prevY: pos - 1,
          directionDown: false,
        });
      }

      if (pos === 0) {
        setScrollPos({ ...scrollPos, directionDown: true });
      }
      lastScrollTop = pos;
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <header
      className={`${props.className ? props.className : ""}${
        scrollPos.y > 5 ? " sticky-header" : ""
      }${scrollPos.directionDown === false ? " header-appear" : ""}${
        scrollPos.directionDown === true && scrollPos.y > 50
          ? " header-disappear"
          : ""
      }${props.type ? ` ${props.type}` : ""}`}
    >
      {props.children}
    </header>
  );
});
/* Header Component End */

/* Headernav Component Start */
export const HeaderNav = (props) => {
  return (
    <Navbar
      id='headerbar'
      expand={props.expand}
      bg={props.bg ? props.bg : "transparent"}
      variant={props.theme}
      className={`${props.menu && `menu-${props.menu}`}${
        props.className ? ` ${props.className}` : ""
      }${props.bg || props.bg === "transparent" ? "" : " header-transparent"}`}
    >
      <Container
        fluid={props.fluid}
        className={props.containerClass ? props.containerClass : ""}
      >
        {props.children}
      </Container>
    </Navbar>
  );
};
/* Headernav Component End */

/* Simplified Header with Logo, Text and Action Button */
export const SimpleHeader = (props) => {
  return (
    <div className='w-full flex justify-between items-center'>
      {/* Logo on left */}
      <div className='flex-shrink-0'>
        <Link to='/' className='navbar-brand'>
          {props.logo}
        </Link>
      </div>

      {/* Middle text - only visible on screens above md breakpoint */}
      <div className='hidden lg:block text-center font-oxana'>
        B2B marketingová agentúra
      </div>

      {/* Action button on right */}
      <div className='flex-shrink-0'>{props.actionButton}</div>
    </div>
  );
};

HeaderLanding.defaultProps = {
  topSpace: {
    desktop: false,
  },
};

HeaderLanding.propTypes = {
  type: PropTypes.string,
  topSpace: PropTypes.object,
};

HeaderNav.defaultProps = {
  fluid: "lg",
  theme: "dark",
  menu: "light",
  expand: "lg",
};

HeaderNav.propTypes = {
  fluid: PropTypes.string,
  theme: PropTypes.string,
  bg: PropTypes.string,
  className: PropTypes.string,
};

SimpleHeader.propTypes = {
  logo: PropTypes.node,
  actionButton: PropTypes.node,
};

export default HeaderLanding;
